if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        if (isMobile()) this.slider();
        this.clickEvent();
      }

      clickEvent = () => {
        let thumbsSlides = qsa('.thumbsSlider .change-main-image',this);
        thumbsSlides.length > 0 && thumbsSlides.forEach(el=>{
          el.addEventListener('click', (event) => {
            this.setActiveSlide(el.getAttribute('data-slide-id'));
          })
        })

        if (!isMobile()) {
          let mainSliderWrapper = qs('.main-slider-wrapper',this);
          mainSliderWrapper.addEventListener('mousemove', function(event) {
            qs('.swiper-slide.active img',mainSliderWrapper).style.transform = `translate3d(0px, -${event.clientY}px, 0px) scale(1)`;
          });
        }
      }

      slider = () => {
        setTimeout(() => {
        this.mainSlider = new Swiper(this.querySelector('.main-slider-wrapper'), {
          zoom: true,
          slidesPerView: 1,
          loop: true,
          // effect: 'fade',
          // freeMode: true
        });
        this.mainSlider.on('slideChange',(e) => {
          let el = qs(`.thumbsSlider [data-slide="${this.mainSlider.realIndex}"]`)
          this.setActiveSlide(el.getAttribute('data-slide-id'),false);
        });
        }, 500);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      setActiveSlide(mediaId,slide = true) {
        if (!mediaId) {
          mediaId = this.openedBy.getAttribute('data-media-id');
        }
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.closest('.swiper-slide')?.classList.remove('active');
        });
        this.querySelectorAll(
          `.thumbsSlider [data-slide-id]:not([data-slide-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const thumbActiveMedia = this.querySelector(`.thumbsSlider [data-slide-id="${mediaId}"]`);
        activeMedia.closest('.swiper-slide')?.classList.add('active');
        thumbActiveMedia.classList.add('active');
        if (isMobile() && this.mainSlider && slide) this.mainSlider.slideTo(parseInt(thumbActiveMedia.dataset.slide));
      }

      showActiveMedia() {
        this.setActiveSlide();
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if(container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
